import React from 'react';
import { Link } from 'react-router-dom';
import { Building2, Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-blue-950 via-blue-900 to-blue-800 text-white mt-20">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo y descripción */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-amber-500 p-2 rounded-lg">
                <Building2 size={28} />
              </div>
              <div>
                <h3 className="text-xl font-bold font-heading">FD-Inmobiliaria</h3>
                <p className="text-sm text-amber-400 font-heading">Inmobiliarios</p>
              </div>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed font-body">
              Tu aliado de confianza en el mercado inmobiliario. Más de 10 años ayudando a familias y empresas a encontrar su lugar ideal.
            </p>
          </div>

          {/* Enlaces rápidos */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-amber-400 font-heading">Enlaces Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-amber-400 transition-colors text-sm font-body">
                  Propiedades
                </Link>
              </li>
              <li>
                <Link to="/?tipo=venta" className="text-gray-300 hover:text-amber-400 transition-colors text-sm font-body">
                  Propiedades en Venta
                </Link>
              </li>
              <li>
                <Link to="/?tipo=renta" className="text-gray-300 hover:text-amber-400 transition-colors text-sm font-body">
                  Propiedades en Renta
                </Link>
              </li>
              <li>
                <Link to="/acerca" className="text-gray-300 hover:text-amber-400 transition-colors text-sm font-body">
                  Acerca de Mí
                </Link>
              </li>
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-amber-400 font-heading">Contacto</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Phone size={18} className="text-amber-400 mt-1 flex-shrink-0" />
                <div>
                  <p className="text-sm text-gray-300 font-body">Teléfono</p>
                  <a href="tel:+525219841387001" className="text-white hover:text-amber-400 transition-colors text-sm font-body">
                    +52 984 1387001
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={18} className="text-amber-400 mt-1 flex-shrink-0" />
                <div>
                  <p className="text-sm text-gray-300 font-body">Email</p>
                  <a href="mailto:ejecutivo@fd-inmobiliaria.homes" className="text-white hover:text-amber-400 transition-colors text-sm font-body">
                    ejecutivo@fd-inmobiliaria.homes
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-amber-400 mt-1 flex-shrink-0" />
                <div>
                  <p className="text-sm text-gray-300 font-body">Oficina</p>
                  <p className="text-white text-sm font-body">Selvanova Coto 9<br/>Playa del Carmen, Quintana Roo</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Horario y redes */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-amber-400 font-heading">Horario</h4>
            <div className="text-sm text-gray-300 mb-6 font-body">
              <p className="mb-1">Lunes a Viernes</p>
              <p className="text-white font-semibold mb-3">9:00 AM - 7:00 PM</p>
              <p className="mb-1">Sábados</p>
              <p className="text-white font-semibold">10:00 AM - 2:00 PM</p>
            </div>
            
            <h4 className="text-sm font-bold mb-3 text-amber-400 font-heading">Síguenos</h4>
            <div className="flex gap-3">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-blue-800 p-2 rounded-lg hover:bg-amber-500 transition-colors"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-blue-800 p-2 rounded-lg hover:bg-amber-500 transition-colors"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-blue-800 p-2 rounded-lg hover:bg-amber-500 transition-colors"
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-blue-800 mt-8 pt-6 text-center">
          <p className="text-gray-300 text-sm font-body">
            © {currentYear} FD-Inmobiliaria. Todos los derechos reservados. | Agente Inmobiliario Certificado
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
